import { useParams } from "react-router-dom";
import ConsentBuilder from "./Builder/ConsentBuilder";
import { useQuery } from "../../utils/hooks";

const RegistryConsentBuilder = () => {
  const { formId } = useParams();
  const versionId = useQuery().get("versionId") || "";

  return (
    <ConsentBuilder
      studyId={""}
      formId={formId || ""}
      versionId={versionId}
      type="platform"
      editable={true}
    />
  );
};

export default RegistryConsentBuilder;
